import { useState } from 'react';
import { toast } from 'sonner';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useCart } from '@/context/CartContext';

function categoryFromProductId(productId) {
  const i = productId.indexOf('-');
  return i > 0 ? productId.slice(0, i) : '';
}

export default function GalleryProductCard({ product, routeCategory }) {
  const { addItem } = useCart();
  const productCategory = categoryFromProductId(product.id);
  const [quantity, setQuantity] = useState(1);

  const handleAdd = () => {
    const q = Math.min(99, Math.max(1, Number(quantity) || 1));
    addItem({
      productId: product.id,
      name: product.name,
      category: productCategory || routeCategory || 'ostalo',
      image: product.image,
      quantity: q,
    });
    toast.success('Dodato u korpu');
  };

  return (
    <Card className="group overflow-hidden border border-black/[0.06] hover:border-primary/20 transition-all duration-300 hover:shadow-md bg-gallery-card shadow-sm flex flex-col">
      <div className="relative flex items-center justify-center overflow-hidden aspect-[4/5] bg-gallery-card p-4 sm:p-5">
        <img
          src={product.image}
          alt={product.name}
          className="max-h-full max-w-full w-auto h-auto object-contain transition-transform duration-500 group-hover:scale-[1.03]"
          loading="lazy"
          decoding="async"
        />
      </div>

      <CardContent className="p-5 bg-gallery-card border-t border-black/[0.06] flex flex-col flex-1 gap-4">
        <div>
          <h3 className="text-lg font-bold text-foreground mb-2 group-hover:text-primary transition-colors line-clamp-2">
            {product.name}
          </h3>
          <p className="text-sm text-muted-foreground">{product.description}</p>
        </div>

        <div className="space-y-3 mt-auto">
          <div>
            <Label htmlFor={`qty-${product.id}`} className="text-xs font-semibold text-foreground">
              Količina
            </Label>
            <Input
              id={`qty-${product.id}`}
              type="number"
              min={1}
              max={99}
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              className="mt-1 h-10"
            />
          </div>

          <Button
            type="button"
            variant="default"
            size="sm"
            className="w-full h-9 rounded-full text-sm font-normal bg-primary hover:bg-primary/90 text-primary-foreground border-0 shadow-sm"
            onClick={handleAdd}
          >
            Dodaj u korpu
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
